import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@core/i18n';
import { AuthService } from './auth.service';

@Component({
  selector: 'app-session-unavailable',
  standalone: true,
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="min-h-screen flex items-center justify-center bg-[var(--bg-page)]">
      <div
        class="bg-[var(--bg-card)] shadow-lg p-8 w-full max-w-md text-center"
        role="alert"
        data-testid="session-unavailable"
      >
        <h1 class="text-lg font-heading font-semibold text-[var(--text-primary)] mb-2">
          {{ 'auth.unavailable.title' | translate }}
        </h1>
        <p class="text-sm text-[var(--text-secondary)] mb-6">
          {{ 'auth.unavailable.message' | translate }}
        </p>
        <button
          type="button"
          data-testid="session-retry"
          [disabled]="auth.sessionChecking()"
          (click)="retry()"
          class="w-full py-2.5 bg-primary-500 text-white rounded-none font-heading font-medium hover:bg-primary-600 disabled:opacity-50 text-sm"
        >
          {{ 'auth.unavailable.retry' | translate }}
        </button>
      </div>
    </div>
  `,
})
export class SessionUnavailableComponent {
  protected readonly auth = inject(AuthService);

  protected retry(): void {
    void this.auth.retrySession();
  }
}
